// @flow
//ESHOP: Osetreni hlavicky eshopu
// import EshopHeader from 'fg-frontend/src/components/EshopHeader';

// COMMON: Intervalovy slider v2 s podporou histogramu (odeberte, pokud nepouzivate ve vypisech produktu komponenty pro filtraci pomoci intervalu, napr. ceny, nebo pokud je pouzita komponenta Slider)
import { RangeSlider } from 'fg-frontend/src/components/RangeSlider';

// COMMON: Komponenta pro rozbalovani/sbalovani obsahu (odeberte, pokud ji nepouzivate ve filtrech, ani v detailu produktu, ani nepouzivate funkci sdileni kosiku a company feature)
import SimpleCollapse from 'fg-frontend/components/SimpleCollapse';

// ESHOP: slider s produkty (odeberte, pokud neni v projektu zapnuta feature productProductRelation ani catalogRecentlyVisitedConfig v ramci catalogTracking feature)
import ProductListSlider from 'fg-frontend/components/ProductListSlider';

// COMMON: Komponenta, ktera vytiskne libovolnou stranku z webu dle jeji URL (odeberte, pokud nepouzivate B2B objednavky, ani sdileni kosiku)
import PrintPage from 'fg-frontend/src/components/PrintPage';

//ESHOP: Fulltextovy naseptavac (odeberte, pokud neni povolena fulltext feature)
import EshopFulltextAutocomplete from 'fg-frontend/src/components/EshopFulltextAutocomplete';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'EshopHeader':
      return import('./components/EshopHeader');
    case 'RangeSlider':
      return RangeSlider;
    case 'SimpleCollapse':
      return SimpleCollapse;
    case 'ProductListSlider':
      return ProductListSlider;
    case 'TopProductsSlider':
      return import('./components/TopProductsSlider');
    case 'PrintPage':
      return PrintPage;
    case 'EshopFulltextAutocomplete':
      return EshopFulltextAutocomplete;
    case 'RadioSelect':
      // COMMON: Podpurna komponenta pro radio select group, ktera zpropaguje change eventu pro ucely PU (odeberte, pokud nepouzivate ve vypisu katalogu komponentu pro razeni ani komponenta pro prepnuti zobrazeni)
      return import('fg-frontend/src/components/RadioSelect');
    case 'CheckboxSelect':
      // COMMON: Komponenta pro podporu hromadneho zaskrtnuti ve skupine checkboxu (odeberte pokud nepouzivate ve vypisech produktu komponenty pro checkboxovou filtraci tagFilter, brandFilter, parameterFilter)
      return import('fg-frontend/src/components/CheckboxSelect');
    //case 'Slider':
      // COMMON: Intervalovy slider v1 bez podpory histogramu (odeberte, pokud nepouzivate ve vypisech produktu komponenty pro filtraci pomoci intervalu, napr. ceny, nebo pokud je pouzita komponeta RangeSlider)
      // return import('fg-frontend/components/Slider');
    case 'NumberInput':
      // COMMON Komponenta pro nastaveni ciselneho mnozstvi (odeberte, pokud v projektu neni nakupni proces)
      return import('fg-frontend/components/NumberInput');
    case 'ListToggle':
      // COMMON: Komponenta pro skryti/zobrazeni casti seznamu (odeberte pokud nepouzivate Nejprodavanejsi produkty ve vypisu produktu, ani vypis parametru v detailu produktu, ani nemate v projektu nakupni proces)
      return import('fg-frontend/components/ListToggle');
    case 'RangeDatepicker':
      // COMMON: Komponenta intervaloveho datepickeru (odeberte, pokud nepouzivate Objednavky v B2B rezimu, nebo Faktury)
      return import('fg-frontend/components/RangeDatepicker');
    case 'AnchorsList':
      // COMMON: Zalozkovy seznam s kotvami (odeberte, pokud nepouzivate v detailu produktu)
      return import('./components/AnchorsList');
    case 'RadioSelectTab':
      // COMMON: Komponenta pro zobrazeni skupiny radio buttonu formou zalozek (odeberte, pokud nepouzivate vychozi komponentu pro razeni produktu)
      return import('fg-frontend/src/components/RadioSelectTab');
    case 'ShareUrl':
      // COMMON: Komponenta, ktera zkopiruje danou URL, resp. string do schranky (odeberte, pokud nepouzivate funkci Ziskat odkaz v detailu produktu ani Sdileni kosiku)
      return import('fg-frontend/src/components/ShareUrl');
    case 'PrintPdf':
      // COMMON: Komponenta, ktera zajistuje tisk PDF (odeberte, pokud nepouzivate Faktury)
      return import('fg-frontend/src/components/PrintPdf');
    case 'RedirectToUrl':
      // COMMON: Komponenta, ktera zajistuje presmerovani po casovem intervalu (odeberte, pokud nepouzivate zadnou platebni branu)
      return import('fg-frontend/src/components/RedirectToUrl');
    case 'Form':
      // COMMON: Komponenta pro osetreni HTML formu (odeberte, pokud nepouzivate vyber variant ve vypisu produktu ani objednavkovy pruvodce)
      return import('fg-frontend/src/components/Form');
    case 'FileInput':
      // COMMON: Komponenta pro vlozeni jedineho souboru (odeberte, pokud nepouzivate Import objednavky z CVS)
      return import('fg-frontend/src/components/FileInput');
    case 'EshopPhotogallery':
      // ESHOP: Produktova fotogalerie
      return import('fg-frontend/components/EshopPhotogallery');
    case 'EshopModel3D':
      // ESHOP: 3D model v ramci produktove fotogalerie (odeberte, pokud neni pozadovana funkcionalita 3D modelu (nastavitelne na fotogalerii))
      return import('fg-frontend/components/EshopModel3D');
    case 'EshopImageMagnify':
      // ESHOP: Lupa v ramci produktove fotogalerie (odeberte, pokud neni pozadovana funkcionalita lupy (nastavitelne na fotogalerii))
      return import('fg-frontend/components/EshopImageMagnify');
    case 'EshopGalleryPopup':
      // ESHOP: Podpora galerie v popupu (odeberte, pokud neni pozadovano chovani galerie v popupu)
      return import('fg-frontend/components/EshopGalleryPopup');
    case 'EshopOrderForm':
      // ESHOP: Podpurna komponenta pro vlozeni zbozi do kosiku (odeberte, pokud nemate v projektu nakupni proces)
      return import('fg-frontend/components/EshopOrderForm');
    case 'BranchPicker':
      // ESHOP: Komponenta pro vyber pobocky v ramci vybranych doprav (odeberte, pokud neni na widgetu pro vyber dopravy nastavene metadato <enableBranchPicker>true</enableBranchPicker>)
      return import('fg-frontend/src/components/BranchPicker');
    case 'EshopVariantStockHandler':
      // ESHOP: Komponenta pro osetreni vyberu variant v detailu produktu (odeberte, pokud neni na komponente nastaveno metadato <enableVariantStockHandler>true</enableVariantStockHandler>)
      return import('fg-frontend/src/components/EshopVariantStockHandler');
    case 'EshopUserToolsHandler':
      // ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani
      return import('./components/EshopUserToolsHandler');
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js